<template>
<el-col style="padding: 16px;">
  <el-row>
    <el-tabs v-loading="loading" type="border-card" >
      <el-tab-pane v-if="!loading" v-for="type in levels" :key="type.o_id" :label="type.name">
        <el-table
          border
          :height="windowHeight - 220"
          :data="usersByClass(type.o_id)">
          <el-table-column
            label="Name"
            :fixed="!isFixed ? false : 'left'"
            sortable
            min-width="150">
            <template slot-scope="scope">
              {{ getFullName(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column
            v-for="obv in cObjectives(type.o_id)"
            align="center"
            :key="obv.o_id"
            :label="obv.obj_num.toString()"
            width="50">
            <template slot-scope="scope">
              <span v-if="userObjective[scope.row.o_id][obv.o_id] == 0" style="color: red;">
              {{ userObjective[scope.row.o_id][obv.o_id] }}
              </span>
              <span v-else-if="userObjective[scope.row.o_id][obv.o_id] >= 2" style="color: #599EF8;">
              {{ userObjective[scope.row.o_id][obv.o_id] }}
              </span>
              <span v-else>
              {{ userObjective[scope.row.o_id][obv.o_id] }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            :fixed="!isFixed ? false : 'right'"
            align="center"
            label="Completion"
            prop="completion"
            width="120">
            <template slot-scope="scope">
              {{ total[scope.row.o_id] }}%
            </template>
          </el-table-column>
        </el-table> 
        <div v-if="terms != null">
          <el-row type="flex" style="margin-top: 8px;" class="bottom">
            <el-select v-model="selectedTerms" style="width: 100%; margin-right: 8px;" multiple placeholder="Select Terms">
              <el-option
                v-for="item in terms"
                :key="item.term"
                :label="item.name"
                :value="item.term">
              </el-option>
            </el-select>
            <el-button  :disabled="selectedTerms.length == 0" class="button" @click="downloadChart(type.o_id)" type="info" size="small" icon="el-icon-download"></el-button>
          </el-row>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-row>
</el-col>
</template>


<script>
import {mapFields} from 'vuex-map-fields';
import Papa from 'papaparse'

export default {
    data() {
        return {
            objectiveLinks: null,
            jsonFields: {}
        };
    },
    computed: {
        ...mapFields([
            'user',
            'users',
            'levels',
            'attendance',
            'terms',
            'selectedTerms',
            'events',
            'objectives'
        ]),
        loading() {
            return !(this.events != null && this.terms != null && this.attendance != null && this.objectives != null && this.objectiveLinks != null);
        },
        userObjective() {
            var ret = [];
            this.users.forEach((user) => {
                ret[user.o_id] = [];
                this.objectives.forEach((objective) => {
                    ret[user.o_id][objective.o_id] = this.objectiveLinks.filter((ol) => {
                        if(ol.objectives.filter((t) => t.o_id == objective.o_id).length == 0){
                            return false;
                        }else if(ol.level.o_id != user.level.o_id){
                            return false;
                        }else if(this.selectedTerms.filter((term) => term == ol.event.term).length == 0){
                            return false;
                        }else if(this.attendance.filter((att) => {
                            if(att.user_id != user.o_id){
                                return false;
                            }else if(att.attendance_type != 1 && att.attendance_type != 4){
                                return false;
                            }else if(att.event_id != ol.event.o_id){
                                return false;
                            }
                            return true;
                        }).length ==0){
                            return false;
                        }
                        return true;
                    }).length;
                });
            });
            return ret;
        },
        total() {
            var ret = [];
            this.users.forEach((user) => {
                var objs = this.cObjectives(user.level.o_id);
                if(objs != null && objs.length != 0){
                    var completed = objs.filter((obj) => this.userObjective[user.o_id][obj.o_id] > 0);
                    ret[user.o_id] = Math.round(completed.length / objs.length * 100);
                }else{
                    ret[user.o_id] = 0;
                }
            });
            return ret;
        },
        termFilters() {
            var t = [];
            this.terms.forEach((term) => {
                t.push({'text': term.name, 'value': term.term});
            });
            return t;
        },
        isFixed() {
            if(this.$mq === 'xs'){
                return false;
            }
            return true;
        }
    },
    mounted(){
        if(this.users == null)
            this.$store.dispatch('pullUsers');
        if(this.terms == null)
            this.$store.dispatch('pullTerms');
        if(this.levels == null)
            this.$store.dispatch('pullLevels');
        if(this.objectives == null)
            this.$store.dispatch('pullObjectives');
        if(this.events == null)
            this.$store.dispatch('pullEvents');
        if(this.attendance == null)
            this.$store.dispatch('pullAttendance');

        this.getObjectiveLinks();
    },
    methods: {
        downloadChart(level) {
            var jsonData = [];
            this.usersByClass(level).forEach((user) => {
                var t = {};
                t.name = this.getFullName(user);
                t.completion = this.total[user.o_id].toString() + '%';
                this.cObjectives(level).forEach((objective) => {
                    var temp = this.userObjective[user.o_id][objective.o_id];
                    t[objective.obj_num] = temp.toString();
                });
                jsonData.push(t);
            });
            var w = Papa.unparse(jsonData);

            var data, filename, link;
            if (w == null) return;

            filename = '.csv';
            this.selectedTerms.forEach((term) => {
                filename = '_' + term + filename;
            });

            filename = this.levels.find((type) => type.o_id == level).name + filename;

            var t;
            if (!w.match(/^data:text\/csv/i)) {
                t = 'data:text/csv;charset=utf-8,' + w;
            }
            data = encodeURI(t);

            if(navigator.msSaveBlob){
                var blob = new Blob([w], {type: 'text/csv;charset=utf-8;'});
                navigator.msSaveBlob(blob, filename);
            }else{
                link = document.createElement('a');
                link.setAttribute('href', data);
                link.setAttribute('download', filename);
                link.click();
            }
        },

        cObjectives(level) {
            if(this.objectives == null){
                return [];
            }
            var t = this.objectives.filter((objective) => {
                return objective.level.filter((nevent) => {return nevent.o_id == level;}).length > 0;
            });
            return t;
        },
        usersByClass(level) {
            return this.users.filter((user) => user.level.o_id == level);
        },
        cName(name) {
            return name == null ? '' : name;
        },
        getObjectiveLinks() {
            this.axios.get('/api/v1/objectives/links',
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                this.objectiveLinks = response.data;
            }).catch((err) => {
                this.$message({
                    showClose: true,
                    message: err.response.data.errors,
                    type: 'error'
                });
            });
        }
    }
}
</script>

